module.exports = __webpack_public_path__ + "img/voucher-bg.8b3be87a.svg";